import React from "react";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href="a"
        ref={ref}
        className="linkTag"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </a>
));

export default CustomToggle;
